import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { colorStyles } from './styles';
const sliderSize = styleUtils.rem(6);
const sliderMarkerStyles = css `
  align-items: center;
  display: flex;
  height: ${sliderSize};
  justify-content: center;
  position: absolute;
  width: ${sliderSize};
`;
const sliderMarkerBorderStyles = css `
  align-items: center;
  border-radius: 50%;
  display: flex;
  height: 100%;
  justify-content: center;
  padding: ${styleUtils.rem(2)};
  width: 100%;
`;
const sliderMarkerInnerStyles = css `
  background-color: ${theme.colors.gray100};
  border-radius: 50%;
  height: 100%;
  width: 100%;
`;
const sliderMarkerContentStyles = css `
  ${theme.typeStyles.bodySmallStyles}
  position: absolute;
  top: calc(${sliderSize} * 2);
  user-select: none;
`;
const defaultProps = {
    content: '',
};
const SliderMarker = ({ color, content = defaultProps.content, hasIndicatorCssAnimation, isSelected, relativePosition, }) => (_jsxs("div", Object.assign({ css: css `
      ${sliderMarkerStyles}
      left: calc(${relativePosition * 100}% - (${sliderSize} / 2));
      will-change: left;
    ` }, { children: [_jsx("div", Object.assign({ css: css `
          ${sliderMarkerBorderStyles}
          ${hasIndicatorCssAnimation && styleUtils.transition('background-color')}
          ${isSelected
                ? colorStyles[color]
                : css `background-color: ${theme.colors.gray400};`}
          will-change: background-color, transition;
          ` }, { children: _jsx("div", { css: sliderMarkerInnerStyles }) })), _jsx("div", Object.assign({ css: sliderMarkerContentStyles }, { children: content }))] })));
const MemoizedSliderMarker = memo(SliderMarker);
export { MemoizedSliderMarker as SliderMarker };
// MC-1068 Temporary hack for Storybook.
export default MemoizedSliderMarker;
